<template>
    <div class="row text-left">
        <div class="col-12">
            <h4>{{ __('payments.Payment with Skrill') }}</h4>

            <div class="col-xs-12">
                <p>{{ __('payments.skrill_siga') }}</p>
                <ol class="m-b-30">
                    <li>{{ __('payments.skrill_escolha') }}<br>
                        <ul class="m-t-15 m-b-15">
                            <li v-for="(plan, index) in plans" v-bind:key="index">USD {{ plan.value }} - {{ __('payments.' + plan.description) }}</li>
                        </ul>
                    </li>
                    <li>{{ __('payments.skrill_transfira') }}<br>
                        <ul>
                            <li><b>Email: dyego@3nw.com.br</b></li>
                        </ul>
                    </li>
                    <li>{{ __('payments.skrill_desc') }}</li>
                    <li>{{ __('payments.skrill_assim') }}</li>
                </ol>
                <p class="m-b-30">{{ __('payments.skrill_fique') }}</p>
                <center>
                    <a class="btn btn-success btn-lg" href="https://help.staketoys.com/" target="_blank">{{ __('payments.skrill_send_msg') }}</a>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['plans'],
    data() {
        return {};
    }
}
</script>
